import React from "react";

type StepItem = {
  id: string;
  title: string;
};

type ProgressStepperProps = {
  steps: StepItem[];
  activeStep: string;
};

export default function ProgressStepper({
  steps,
  activeStep,
}: ProgressStepperProps) {
  const activeIndex = steps.findIndex((step) => step.id === activeStep);

  return (
    <div className="rounded-[28px] border border-[#E5E7EB] bg-white/90 p-4 shadow-sm backdrop-blur">
      <div className="mb-3 flex items-center justify-between gap-3">
        <div>
          <div className="text-xs font-semibold uppercase tracking-[0.1em] text-[#6B7280]">
            Onboarding
          </div>
          <div className="text-lg font-semibold text-[#0F172A]">
            Step {activeIndex + 1} of {steps.length}
          </div>
        </div>
        <div className="text-sm text-[#6B7280]">{steps[activeIndex]?.title}</div>
      </div>

      <div className="grid grid-cols-5 gap-2">
        {steps.map((step, index) => {
          const isComplete = index < activeIndex;
          const isActive = index === activeIndex;
          return (
            <div key={step.id} className="flex items-center gap-2">
              <div
                className={`flex h-9 w-9 items-center justify-center rounded-full border text-sm font-semibold ${
                  isComplete || isActive
                    ? "border-[#93C893] bg-[#EEF9EE] text-[#166534]"
                    : "border-[#E5E7EB] bg-[#F8FAFC] text-[#94A3B8]"
                }`}
              >
                {index + 1}
              </div>
              {index < steps.length - 1 && (
                <div
                  className={`hidden h-1 flex-1 rounded-full sm:block ${
                    isComplete ? "bg-[#93C893]" : "bg-[#E5E7EB]"
                  }`}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
